import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiShield, FiEye, FiEyeOff } from 'react-icons/fi';
import { loginSuperAdmin } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import styles from './LoginRegister.module.css';

const SuperAdminLogin = () => {
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({ identifier: '', password: '' });

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await loginSuperAdmin({ identifier: form.identifier, password: form.password });
      loginUser(res.data);
      navigate('/super-admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.leftPanel}>
        <div className={styles.brandLogo}><FiShield /></div>
        <div className={styles.brandName}>Super Admin</div>
        <div className={styles.brandTagline}>Platform administration portal</div>
        <div className={styles.features}>
          {[
            'Approve & manage derasars',
            'Subscription management',
            'Platform-wide oversight',
            'User & role management',
          ].map((f) => (
            <div key={f} className={styles.featureItem}>
              <div className={styles.featureIcon}><FiShield size={13} /></div>
              {f}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.rightPanel}>
        <div className={styles.formContainer}>
          <h2 className={styles.formTitle}>Super Admin Sign In</h2>
          <p className={styles.formSubtitle}>Restricted access — authorised personnel only</p>

          {error && <div className={styles.errorMsg}>{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email or Phone Number *</label>
              <input
                name="identifier"
                type="text"
                value={form.identifier}
                onChange={handleChange}
                placeholder="Enter email or phone number"
                required
                autoComplete="username"
              />
            </div>
            <div className="form-group" style={{ position: 'relative' }}>
              <label>Password *</label>
              <input
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={form.password}
                onChange={handleChange}
                required
                minLength={6}
                autoComplete="current-password"
                style={{ paddingRight: '40px' }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '36px',
                  cursor: 'pointer',
                  color: 'var(--color-text-light)'
                }}
              >
                {showPassword ? <FiEye /> : <FiEyeOff />}
              </span>
            </div>
            <div style={{ textAlign: 'right', marginTop: 4, marginBottom: 4 }}>
              <Link to="/forgot-password" style={{ fontSize: '0.8rem', color: 'var(--color-primary)', textDecoration: 'none' }}>
                Forgot password?
              </Link>
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={loading} style={{ marginTop: 8 }}>
              {loading ? 'Please wait…' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
